'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setupReact;

var _reactDom = require('react-dom');

var hub = _reactDom.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.EventPluginHub;

function setupReact() {
  hub.injection.injectEventPluginsByName({
    ResponderEventPlugin: {
      extractEvents: function extractEvents(topLevelType, targetInst, nativeEvent) {
        if (topLevelType !== 'topClick' || !targetInst) {
          return;
        }

        var currentElement = targetInst._debugOwner;

        var names = [];
        while (currentElement) {
          var name = currentElement.type.displayName || currentElement.type.name;
          if (name) {
            names.push(name);
          }
          currentElement = currentElement._debugOwner;
        }

        // eslint-disable-next-line no-param-reassign
        nativeEvent.__lrName = names;
      }
    }
  });
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/logrocket-react/dist/index.js
// module id = 957
// module chunks = 0